import axios from "axios";
import { IUser } from "constants/interfaces/user.interface";

/**
 * Método que obtiene la información del usuario.
 *
 * @param {string} accessToken Token de acceso.
 * @returns {Promise<IUser>} Información del usuario.
 */
export const getUserInfo = async (accessToken: string): Promise<IUser> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GCR_URL}/consultores/datosUsuario`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    const user: IUser = {
      name: response.data.Nombre,
      firstName: response.data.ApPaterno,
      lastName: response.data.ApMaterno,
      rut: response.data.Rut,
    };

    return user;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
